<glxy-form-field bottomSpacing="false" minWidth="200px" maxWidth="200px">
  <mat-select [ngModel]="currentSelection$ | async" (ngModelChange)="changeDate($event)">
    <mat-option *ngFor="let monthYear of monthYearRevenueFilterList" [value]="monthYear">
      {{ monthYear.displayString | async }}
    </mat-option>
  </mat-select>
</glxy-form-field>
